import React from "react";
import './jigyasa-assessment.scss';
import StartAssessment from "./start-assessment/start-assessment";
import HomeworkApi from "../../apis/homework";
import LayoutShared from "../common/layout-shared/layout-shared";
// import SharedProfile from "../../../shared-storage/profile";
import ClickerFlowPracticeStat from "./clicker-flow-practice-stat/clicker-flow-practice-stat";
import ClassworkHeader from "./my-classwork-header/my-classwork-header";
import ClickerAssessmentEngine from "./clicker-assessment-engine/clicker-assessment-engine";
import ClickerOfflineAssessmentEngine from "./clicker-assessment-engine-offline/clicker-assessment-engine-offline";
import ClickerAssessmentEndScreen from "./assessment-end-screen/assessment-end-screen";
import CommonApi from "../../apis/common";
import IndexedDBHelper from "../../offline/apis/indexDBManager";
import { Constants } from "../../constants/constants";
import IndexedDBHelperV2 from "../../offline/apis/indexDBManager-v2";
import CommonUtils from "../../utility/common-utilities";
import ToasterComponent from "../common/cw-toaster-component/cw-toaster-component";
import { Modal, ModalBody } from "reactstrap";
import { getImageSource } from "../../utility/image-source";
import { ImageConstants } from "../../constants/constants";
import SessionCache from "../routes/session-cache";
import SchoolApi from "../../apis/school";

let { Parser } = require('json2csv');
const dbHelper = new IndexedDBHelperV2(Constants.DB_NAME, Constants.DB_VERSION, Constants.STORE_CONFIG);

const base64ToBlob = (base64, mimeType) => {
    const binary = atob(base64); // Decode Base64
    const array = Uint8Array.from(binary, char => char.charCodeAt(0)); // Convert to byte array
    return new Blob([array], { type: mimeType });
};


class ClickerFlowPractice extends React.Component {
    state = {
        imageUrls: [],
        // usersList: [
        //     {
        //         userId: '659b90fa21cb4f53081b46a9',
        //         studentNumber: '100',
        //         userDeviceMacId: 'bf:fc:e2:0e:93:e7',
        //         receivedAnswer: false,
        //         isTeacher: true,
        //     },
        //     {
        //         userId: '66f7f50bdb22843a4fb5c860',
        //         studentNumber: '21',
        //         userDeviceMacId: '58:2f:be:86:1c:ee',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '66f7f50bdb22843a4fb5c861',
        //         studentNumber: '22',
        //         userDeviceMacId: 'ef:3f:4d:11:ef:c7',
        //         receivedAnswer: false,
        //     }
        // ],
        showDownloadReportPopup: false,
        // Production Users List
        // usersList: [
        //     {
        //         teacherUserId: '659b90fa21cb4f53081b46a9',
        //         studentNumber: '100',
        //         userDeviceMacId: 'bd:d0:04:05:db:d8',
        //         receivedAnswer: false,
        //         isTeacher: true,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46a7',
        //         studentNumber: '1',
        //         userDeviceMacId: '7c:0c:d3:ef:9b:d8',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46a8',
        //         studentNumber: '2',
        //         userDeviceMacId: '65:05:df:31:dd:fe',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46aa',
        //         studentNumber: '3',
        //         userDeviceMacId: '26:05:e8:5b:ed:d1',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ab',
        //         studentNumber: '4',
        //         userDeviceMacId: '98:83:8f:a6:9c:fa',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ac',
        //         studentNumber: '5',
        //         userDeviceMacId: 'b5:de:e9:93:c5:c2',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ad',
        //         studentNumber: '6',
        //         userDeviceMacId: 'c9:ee:61:02:61:d8',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ae',
        //         studentNumber: '7',
        //         userDeviceMacId: '28:56:46:47:b8:f4',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46af',
        //         studentNumber: '8',
        //         userDeviceMacId: '98:95:c3:0d:4b:fa',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b0',
        //         studentNumber: '9',
        //         userDeviceMacId: '39:76:8d:c4:b5:e3',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b1',
        //         studentNumber: '10',
        //         userDeviceMacId: 'ba:97:f2:01:91:ce',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b2',
        //         studentNumber: '11',
        //         userDeviceMacId: '05:d0:84:1f:a9:c9',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b3',
        //         studentNumber: '12',
        //         userDeviceMacId: 'bd:53:3b:30:15:ed',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b4',
        //         studentNumber: '13',
        //         userDeviceMacId: '7a:89:0f:87:42:eb',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b5',
        //         studentNumber: '14',
        //         userDeviceMacId: '72:87:f4:33:b9:d8',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b6',
        //         studentNumber: '15',
        //         userDeviceMacId: '09:65:11:75:bd:de',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b7',
        //         studentNumber: '16',
        //         userDeviceMacId: '93:86:69:41:2f:fd',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b8',
        //         studentNumber: '17',
        //         userDeviceMacId: 'ca:b1:a7:e1:6c:dc',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46b9',
        //         studentNumber: '18',
        //         userDeviceMacId: '17:0d:52:8c:8a:cb',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46ba',
        //         studentNumber: '19',
        //         userDeviceMacId: '122',
        //         receivedAnswer: false,
        //     },
        //     {
        //         userId: '659b90fa21cb4f53081b46bb',
        //         studentNumber: '20',
        //         userDeviceMacId: '123',
        //         receivedAnswer: false,
        //     }
        // ],
        showStartAssessment: true,
        showBarChart: false,
        content: [],
        isReload: true,
        // showAssessmentEndScreen : true
    }

    constructor(props) {
        super(props);
        this.layoutShared = LayoutShared.getLayout()
        console.log(this.props.meta)

    }

    componentDidMount() {
        if (this.props.meta &&
            (this.props.meta.type === 'CLICKER_ASSESSMENT' || this.props.meta.type === Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT)) {
            this.onClickCard(this.props.meta)
        } else {
            this.getTeacherHomeworkActivities()
        }
        if (window.electron) {
            this.resetZoom()
        }
    }

    resetZoom() {
        window.electron.ipcRenderer.send('reset-zoom', ['ping'])
    }

    getTeacherHomeworkActivities() {
        let payload = {}

        payload.type = ["JIGYASA_ASSESSMENT"]

        if (CommonUtils.isOnline()) {
            this.setState({ isReload: false })
            HomeworkApi.getTeacherHomeworkActivities(payload).then(res => {
                // console.log(res)
                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'type', 'JIGYASA_ASSESSMENT').then(localRes => {
                    // console.log(localRes)

                    let homeworkListHash = {}

                    localRes.forEach(item => homeworkListHash[item._id] = item)
                    if (res.contents.length > 0) {
                        let completedHomework = [], notCompletedHomework = []
                        res.contents.forEach(item => {
                            if (item.status === 'COMPLETED') {
                                completedHomework.push(item)
                            } else {
                                notCompletedHomework.push(item)
                            }

                            if (homeworkListHash[item._id]) {
                                console.log(homeworkListHash[item._id].status)
                                item.status = homeworkListHash[item._id].status
                                item.pendingSync = homeworkListHash[item._id].pendingSync ? homeworkListHash[item._id].pendingSync : false
                            }
                        })
                        this.setState({ content: res.contents, completedHomework, notCompletedHomework, isReload: true })
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        } else {
            let userInfo = SessionCache.getUser()

            if (userInfo && userInfo.schoolInfo && userInfo.schoolInfo.schoolCode) {
                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'schoolId', userInfo.schoolInfo.schoolCode).then(res => {
                    // console.log(res)

                    res = res.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))

                    this.setState({ content: res })
                }).catch(err => {
                    console.log(err)
                })
            } else {
                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'type', 'JIGYASA_ASSESSMENT').then(res => {
                    // console.log(res)

                    res = res.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))

                    this.setState({ content: res })
                }).catch(err => {
                    console.log(err)
                })
            }


        }
    }



    onClickCard(item) {
        this.getHomeworkStatus(item)
    }


    getHomeworkStatus = (item) => {
        if (item.type == 'JIGYASA_ASSESSMENT' ||
            item.type == 'CLICKER_ASSESSMENT' ||
            item.type == Constants.CLICKER_CONCEPT_CARD_WITH_ASSESSMENT) {
            this.handleAssessmenets(item)
            return
        }
    }

    toggleLayoutBar() {
        console.log('toggle called')

        // this.setState({hideLayoutSideBar : !this.state.hideLayoutSideBar}, () => {
        // this.layoutShared.showHideLayoutBar(!this.layoutShared.state.showLayoutBar)
        if(window.electron && window.electron.ipcRenderer) {
            window.electron.ipcRenderer.send('toggle-fullscreen', { fullscreen: true });
        }
        
        // this.layoutShared.toggleSidebar(this.state.hideLayoutSideBar)
        // })

    }

    handleAssessmenets = (item) => {

        // let chapterKey = item.chapters.map(data => data.key)

        // let chapters = []

        // for (let i = 0; i < item.chapters.length; i++) {
        //     chapters.push(item.chapters[i].title)
        // }

        console.log(item)

        let payload = {
            board: item.board,
            class: item.class,
            sectionId: item.sectionId,
            homeworkId: item.homeworkId // added this key to get the Clicker List when we have inter schools competition in quiz module
        }


        if (item.isDownloaded && CommonUtils.isOnline) {
            console.log('setting to offline')
            this.layoutShared.forceOffline(true, item)
            // CommonUtils.setOffline()
        }


        if (CommonUtils.isOnline()) {
            // CommonApi.getStudentClickerList(payload).then(res => {
            // console.log(res)
            if (item.status == 'ASSIGNED') {
                // this.layoutShared.toggleSidebar(true, this.props.history.location.pathname)
                this.setState({
                    showAssessmentStartScreen: true,
                    // usersList: res.clickerUserList,
                    startAssessmentMetaInfo: {
                        chapterKey: "",
                        chapterTitle: item.chapters && item.chapters.length ? item.chapters[0].title : item.chapterTitle,
                        categoryThemeId: item.categoryId,
                        selectedChapters: item.chapters && item.chapters.length > 1 ? item.chapters : null,
                        homeworkChapters: "",
                        duration: item.duration,
                        isFromMyHomework: true,
                        isFromMyClasswork: true,
                        homeworkActivityId: item._id,
                        isDueDatePassed: item.isDueDatePassed,
                        viewAnswerTime: item.endTime,
                        homework: item,
                        from: "CLASSWORK",
                        clickerSet: item.clickerSet
                    }
                })
            } else if (item.status == 'IN_PROGRESS') {

                let payload = {
                    selectedSetId: item.selectedSetId,
                    homeworkId: item.homeworkId
                }
                this.toggleLayoutBar()

                SchoolApi.getUserClickerList(payload).then(clickerUserRes => {
                    console.log(clickerUserRes)
                    this.setState({ usersList: clickerUserRes.clickerUserList })

                    this.showAssessmentEngine(
                        {
                            chapterTitle: item.chapters && item.chapters.length ? item.chapters[0].title : "",
                            isResume: true,
                            assessmentActivityId: item.assessmentActivityId,
                            categoryThemeId: item.categoryId,
                            selectedChapters: item.chapters,
                            isFromMyHomework: true,
                            homeworkChapters: "",
                            homeworkActivityId: item._id,
                            isDueDatePassed: item.isDueDatePassed,
                            viewAnswerTime: item.endTime,
                            homework: item,
                            chapterKey: "",
                            from: "CLASSWORK",
                            usersList: clickerUserRes.clickerUserList
                        }
                    )
                }).catch(err => {
                    console.log(err)
                })
            }
            // }).catch(err => {
            //     console.log(err)
            // })
        } else {
            dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', item.homeworkId).then(teacherHomeworkActivityData => {
                let teacherHomeworkActivity = teacherHomeworkActivityData[0]

                console.log(teacherHomeworkActivity)

                let userIds = teacherHomeworkActivity.userIdsList
                // To Add Teacher UserId
                userIds.push(teacherHomeworkActivity.userId)

                dbHelper.getAllFromIndex(Constants.USER_ASSESSMENT_ACTIVITY_STORE, 'schoolAssessmentId', item.homeworkId).then(res => {
                    // console.log(res)

                    // let ids = res.map(item => item.userId)

                    dbHelper.getAllByIds(Constants.CLICKER_USERS_STORE, teacherHomeworkActivity.userIdsList).then(clickerUserList => {
                        clickerUserList = clickerUserList.sort((a, b) => a.studentNumber - b.studentNumber)
                        // console.log(clickerUserList)

                        if (item.status == 'ASSIGNED') {
                            // this.layoutShared.toggleSidebar(true, this.props.history.location.pathname)
                            this.setState({
                                showAssessmentStartScreen: true,
                                usersList: clickerUserList,
                                startAssessmentMetaInfo: {
                                    chapterKey: "",
                                    chapterTitle: item.chapters && item.chapters.length ? item.chapters[0].title : item.chapterTitle,
                                    categoryThemeId: item.categoryId,
                                    selectedChapters: item.chapters && item.chapters.length > 1 ? item.chapters : null,
                                    homeworkChapters: "",
                                    duration: item.duration,
                                    isFromMyHomework: true,
                                    isFromMyClasswork: true,
                                    homeworkActivityId: item._id,
                                    isDueDatePassed: item.isDueDatePassed,
                                    viewAnswerTime: item.endTime,
                                    homework: item,
                                    from: "CLASSWORK",
                                    clickerSet: teacherHomeworkActivity.clickerSet
                                }
                            })
                        } else if (item.status == 'IN_PROGRESS') {
                            // console.log('here')
                            this.toggleLayoutBar()

                            let selectedClickerSet = teacherHomeworkActivity.clickerSet.filter(item => item.value === teacherHomeworkActivity.selectedSetId)

                            let studentClickerList = selectedClickerSet[0].studentClickerList
                            let teacherClickerId = selectedClickerSet[0].teacherClickerId

                            let studentClickerListhash = {}

                            for (let i = 0; i < studentClickerList.length; i++) {
                                studentClickerListhash[i + 1] = studentClickerList[i]
                            }

                            clickerUserList.forEach(item => {
                                if (studentClickerListhash[item.studentNumber]) {
                                    item.userDeviceMacId = studentClickerListhash[item.studentNumber].deviceMacId
                                } else if (item.isTeacher) {
                                    item.userDeviceMacId = teacherClickerId.deviceMacId
                                }
                            })

                            // let teacherObj = {
                            //     userId: teacherHomeworkActivity.userId,
                            //     studentNumber: '1000',
                            //     userDeviceMacId: teacherClickerId.deviceMacId,
                            //     receivedAnswer: false,
                            //     isTeacher: true,
                            // }

                            // clickerUserList.push(teacherObj)

                            console.log(clickerUserList)


                            this.setState({ usersList: clickerUserList })

                            this.showAssessmentEngine(
                                {
                                    chapterTitle: item.chapters && item.chapters.length ? item.chapters[0].title : "",
                                    isResume: true,
                                    assessmentActivityId: item.assessmentActivityId,
                                    categoryThemeId: item.categoryId,
                                    selectedChapters: item.chapters,
                                    isFromMyHomework: true,
                                    homeworkChapters: "",
                                    homeworkActivityId: item._id,
                                    isDueDatePassed: item.isDueDatePassed,
                                    viewAnswerTime: item.endTime,
                                    homework: item,
                                    chapterKey: "",
                                    from: "CLASSWORK",
                                    usersList: clickerUserList

                                }
                            )
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }


    }


    hideStartAssessmentScreen() {
        
        this.setState({ showAssessmentStartScreen: false }, () => {
            this.props.delegate.showClickerAssessmentList && this.props.delegate.showClickerAssessmentList()
        })
    }

    showAssessmentEngine(data) {
        //console.log(data)
        this.setState({ showAssessmentEngine: true, showAssessmentStartScreen: false, assessmentEngineMetaInfo: data, usersList: data.usersList })
    }

    showAssessmentEndScreen(assessmentCompletedInfo) {
        console.log(assessmentCompletedInfo)
        this.setState({ showAssessmentEngine: false, showAssessmentEndScreen: true, assessmentCompletedMetaInfo: assessmentCompletedInfo })
    }

    hideAssessmentEndScreen() {
        this.setState({ showAssessmentEndScreen: false }, () => {
            this.getUserHomeworkActivities({}, null, null, true);
        })
    }

    toggleFullScreenLoading = (value, callback) => {
        this.setState({ fullScreenLoading: value }, () => {
            callback && callback()
        })
    }

    base64ToBlobUrl = (base64Data, contentType) => {
        // Decode base64 to binary
        const binaryData = atob(base64Data);
        const byteArray = new Uint8Array(binaryData.length);

        // Create an array of 8-bit unsigned integers to hold binary data
        for (let i = 0; i < binaryData.length; i++) {
            byteArray[i] = binaryData.charCodeAt(i);
        }

        // Create Blob from byte array
        const blob = new Blob([byteArray], { type: contentType });
        // return URL.createObjectURL(blob);
        return blob;
    };


    onClickDownload(item, callback) {
        // console.log(item)
        // console.log(dbHelper)

        let payload = {}

        payload.isFromMyHomework = true
        payload.homeworkActivityId = item._id

        payload.board = item.board
        payload.class = item.class
        payload.sectionId = item.sectionId

        HomeworkApi.downloadOfflineUserAssessmentActivity(payload).then(response => {
            console.log(response)
            if (response.userAssessmentActivity.length && response.contentsList.length && response.clickerUserList.length) {
                item.isDownloaded = true
                item.assessmentActivityId = response.assessmentActivityId
                // const urls = response.updatedImageObjects
                //     .map(image => {
                //         if (image.buffer && image.mimeType) {
                //             const blob = base64ToBlob(image.buffer, image.mimeType);
                //             return URL.createObjectURL(blob);
                //         }
                //         return null;
                //     })
                //     .filter(Boolean); // Filter out any null entries

                response.contentsList.forEach(contentItem => {
                    let content = contentItem.content
                    if (content.images && content.images.length) {
                        content.images.forEach(item => {
                            const [contentType, base64Data] = item.base64Data.split(';base64,');
                            const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                            delete item.base64Data
                            item.imageBlob = imageBlob

                        })
                    }

                    if (content.options && content.options.length) {
                        content.options.forEach(option => {
                            if (option.contentTypeName === 'IMAGE' && option.base64Data) {
                                const [contentType, base64Data] = option.base64Data.split(';base64,');
                                const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                                delete option.base64Data
                                option.imageBlob = imageBlob
                            }
                        })
                    }

                    // For Multi Step

                    if (content.isMultiStep && content.steps && content.steps.length) {
                        content.steps.forEach(stepContentItem => {
                            let stepContent = stepContentItem.content
                            if (stepContent.images && stepContent.images.length) {
                                stepContent.images.forEach(item => {
                                    const [contentType, base64Data] = item.base64Data.split(';base64,');
                                    const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                                    delete item.base64Data
                                    item.imageBlob = imageBlob
                                })
                            }

                            if (stepContent.options && stepContent.options.length) {
                                stepContent.options.forEach(option => {
                                    if (option.contentTypeName === 'IMAGE' && option.base64Data) {
                                        const [contentType, base64Data] = option.base64Data.split(';base64,');
                                        const imageBlob = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                                        delete option.base64Data
                                        option.imageBlob = imageBlob
                                    }
                                })
                            }

                        })
                    }
                })

                // const urls = response.updatedImageObjects.map((item) => {
                //     const images = item.images.map((item) => {
                //         const [contentType, base64Data] = item.base64Data.split(';base64,');
                //         const blobUrl = this.base64ToBlobUrl(base64Data, contentType.split(':')[1]);
                //         return { imageUrl: item.imageUrl, blobUrl }
                //     });
                //     return { id: item.id, images };
                // });

                console.log(response.contentsList)

                // this.setState({ imageUrls: urls });

                let dataArray = [item]
                dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, dataArray).then(res => {
                    // console.log(res)
                    dbHelper.updateBulkData(Constants.USER_ASSESSMENT_ACTIVITY_STORE, response.userAssessmentActivity).then(activityRes => {
                        // console.log(activityRes)
                        dbHelper.updateBulkData(Constants.CONTENTS_STORE, response.contentsList).then(contentRes => {
                            console.log(contentRes)
                            // this.updateItem(item._id)
                            dbHelper.updateBulkData(Constants.CLICKER_USERS_STORE, response.clickerUserList).then(userListUpdatedRes => {
                                console.log(userListUpdatedRes)
                                callback(null, true)
                            })
                        })
                    })
                })
            }
            else {
                this.showToaster('error', `Due to Internet issue Assessment Not Downloaded`)
            }

        }).catch(err => {
            console.log(err)
            callback(err, false)
        })

        // Download the Data

        // dbHelper.addBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, dataArray).then(res => {
        //     console.log(res)
        // }).catch(err => {
        //     console.log(err)
        // })

        // To Get the Data from the DB

        // dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'type', 'JIGYASA_ASSESSMENT').then(res => {
        //     console.log(res)
        // }).catch(err => {
        //     console.log(err)
        // })

        // dbHelper.getAllFromIndex(Constants.USER_ASSESSMENT_ACTIVITY_STORE, 'schoolAssessmentId', item.homeworkId).then(res => {
        //     console.log(res)
        // }).catch(err => {
        //     console.log(err)
        // })

        // dbHelper.getAllData(Constants.CONTENTS_STORE).then(res => {
        //     console.log(res)
        // }).catch(err => {
        //     console.log(err)
        // })


    }


    updateItem = (id, homeworkItem, type) => {


        if (type === 'DOWNLOAD') {

            this.setState((prevState) => ({
                content: prevState.content.map((item) =>
                    item._id === id ? { ...item, isDownloading: true } : item
                )
            }));

            this.onClickDownload(homeworkItem, (err, res) => {
                // console.log(res)
                if (res) {
                    this.showToaster('info', `${homeworkItem.schoolName}-${homeworkItem.class}${homeworkItem.section}-${homeworkItem.medium} Downloaded Successfully`)
                    this.setState((prevState) => ({
                        content: prevState.content.map((item) =>
                            item._id === id ? { ...item, isDownloaded: true, isDownloading: false } : item
                        )
                    }));
                }
            })
        }

        if (type === 'SYNC') {

            if (!CommonUtils.isOnline()) return

            this.onClickSync(homeworkItem, (err, res) => {
                // console.log(res)
                homeworkItem.pendingSync = false
                // console.log(homeworkItem)
                let dataArray = [homeworkItem]

                this.setState((prevState) => ({
                    content: prevState.content.map((item) =>
                        item._id === id ? { ...item, isDownloaded: true, pendingSync: false, isSynchronizing: true } : item
                    )
                }));

                dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, dataArray).then(updateTeacherActivityRes => {
                    if (res) {
                        this.showToaster('info', `${homeworkItem.schoolName}-${homeworkItem.class}${homeworkItem.section}-${homeworkItem.medium} Synced Successfully`)
                        this.setState((prevState) => ({
                            content: prevState.content.map((item) =>
                                item._id === id ? { ...item, isDownloaded: true, pendingSync: false, isSynchronizing: false } : item
                            )
                        }));
                    }
                }).catch(err => {
                    console.log(err)
                })

            })
        }
    };


    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 10000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }


    onClickSync(homeworkItem, callback) {
        console.log(homeworkItem)
        dbHelper.getAllFromIndex(Constants.USER_ASSESSMENT_ACTIVITY_STORE, 'schoolAssessmentId', homeworkItem.homeworkId).then(activity => {
            console.log(activity)
            let payload = {
                activity,
                homeworkId: homeworkItem.homeworkId
            }
            HomeworkApi.syncOfflineUserAssessmentActivity(payload).then(synCompletedRes => {
                callback(null, true)
            })
        }).catch(err => {
            console.log(err)
            callback(err, false)
        })
    }



    downloadQuestionWisePercentageAndFeedbackReport(item) {

        let assessmentName = `${item.schoolName}-${item.class}${item.section}-${item.medium}`
        let payload = {
            assessmentActivityId: item.assessmentActivityId,
            isFromMyHomework: true,
            class: item.class,
            section: item.section
        }

        HomeworkApi.downloadQuestionWisePercentageReport(payload).then(res => {
            // console.log(res)
            this.setState({
                assessmentName, questionwisePercentage: res.assessmentQuestionWiseStudentInfo,
                feedbackReport: res.userFeedback,
                studentQuestionDetails: res.studentQuestionDetails,
                studentSummary: res.studentSummary,
                showDownloadReportPopup: true
            })
        }).catch(err => {
            console.log(err)
        })
    }

    hideReportModal = () => {
        this.setState({ showDownloadReportPopup: false })
    }

    downloadQuestionwiseReportExcel() {


        // Fow Questionwise Percentage Report Download

        let assessmentQuestionWiseStudentInfo = this.state.questionwisePercentage

        if (assessmentQuestionWiseStudentInfo && assessmentQuestionWiseStudentInfo.length) {
            let csvBuild = []
            for (let i = 0; i < assessmentQuestionWiseStudentInfo.length; i++) {
                let item = assessmentQuestionWiseStudentInfo[i]

                let obj = {
                }

                if (item["state"]) {
                    obj['State'] = item["state"]
                }

                if (item["location"]) {
                    obj['Location'] = item["location"]
                }

                if (item["schoolName"]) {
                    obj['School'] = item["schoolName"]
                }
                if (item["grade"]) {
                    obj['Class'] = item["grade"]
                }
                if (item["section"]) {
                    obj['Section'] = item["section"]
                }

                if (item["projectName"]) {
                    obj['Project Name'] = item["projectName"]
                }

                if (item["dateOfAssessment"]) {
                    let dateFormat = new Date(item['dateOfAssessment']).toLocaleString('en-ZA').split(',');
                    obj['Date of Assessment'] = dateFormat[0]
                }

                if (item["examYear"]) {
                    obj['Exam Year'] = item["examYear"]
                }



                if (item["questionNumber"]) {
                    obj['Question Number'] = item["questionNumber"]
                }

                if (item["questionTitle"]) {
                    obj['Question'] = item["questionTitle"]
                }

                if (item["competencyThinkingSkill"]) {
                    obj['Competency'] = item["competencyThinkingSkill"]
                }

                if (item["complexity"]) {
                    obj['Complexity'] = item["complexity"]
                }

                if (item["mark"]) {
                    obj['Mark'] = item["mark"]
                }


                if (item["correctStudentsCount"]) {
                    obj['Cleared Students Count'] = item["correctStudentsCount"]
                } else {
                    obj['Cleared Students Count'] = 0
                }

                if (item["clearedPercentage"]) {
                    obj['Cleared Percentage'] = item["clearedPercentage"]
                } else {
                    obj['Cleared Percentage'] = 0
                }

                csvBuild.push(obj)
            }
            let json2csvParser = new Parser();
            let csv = json2csvParser.parse(csvBuild);

            // console.log(csv);

            let hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = `${this.state.assessmentName}_Questionwise_Percentage_Report_` + (new Date).toISOString() + '.csv';
            hiddenElement.click();
        }
    }

    downloadFeedbackReportExcel() {

        //  For Feedback Report

        let userFeedback = this.state.feedbackReport

        if (userFeedback && userFeedback.length) {
            let csvBuild = []
            for (let i = 0; i < userFeedback.length; i++) {
                let item = userFeedback[i]

                let obj = {
                }

                if (item["state"]) {
                    obj['State'] = item["state"]
                }

                if (item["location"]) {
                    obj['Location'] = item["location"]
                }

                if (item["schoolName"]) {
                    obj['School'] = item["schoolName"]
                }
                if (item["grade"]) {
                    obj['Class'] = item["grade"]
                }
                if (item["section"]) {
                    obj['Section'] = item["section"]
                }


                if (item["studentNumber"]) {
                    obj['Roll No'] = item["studentNumber"]
                }
                if (item["gender"]) {
                    obj['Gender'] = item["gender"]
                }
                if (item["studentCode"]) {
                    obj['Student Code'] = item["studentCode"]
                }
                if (item["name"]) {
                    obj['Student Name'] = item["name"]
                }

                if (item["projectName"]) {
                    obj['Project Name'] = item["projectName"]
                }

                if (item["dateOfAssessment"]) {
                    let dateFormat = new Date(item['dateOfAssessment']).toLocaleString('en-ZA').split(',');
                    obj['Date of Assessment'] = dateFormat[0]
                }

                if (item["examYear"]) {
                    obj['Exam Year'] = item["examYear"]
                }



                if (item["Question1"]) {
                    obj['Question 1'] = item["Question1"]
                }

                if (item["Answer1"]) {
                    obj['Answer 1'] = item["Answer1"]
                }

                if (item["Question2"]) {
                    obj['Question 2'] = item["Question2"]
                }

                if (item["Answer2"]) {
                    obj['Answer 2'] = item["Answer2"]
                }

                if (item["Question3"]) {
                    obj['Question 3'] = item["Question3"]
                }

                if (item["Answer3"]) {
                    obj['Answer 3'] = item["Answer3"]
                }

                if (item["Question4"]) {
                    obj['Question 4'] = item["Question4"]
                }

                if (item["Answer4"]) {
                    obj['Answer 4'] = item["Answer4"]
                }

                csvBuild.push(obj)
            }
            let json2csvParser = new Parser();
            let csv = json2csvParser.parse(csvBuild);

            // console.log(csv);

            let hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = `${this.state.assessmentName}_Assessment_Feedback_Report_` + (new Date).toISOString() + '.csv';
            hiddenElement.click();
        }
    }

    downloadStudentSummaryReportExcel() {

        //  For Feedback Report

        let userFeedback = this.state.studentSummary

        if (userFeedback && userFeedback.length) {
            let csvBuild = []
            for (let i = 0; i < userFeedback.length; i++) {
                let item = userFeedback[i]

                let obj = {
                }

                if (item["state"]) {
                    obj['State'] = item["state"]
                }

                if (item["location"]) {
                    obj['Location'] = item["location"]
                }

                if (item["schoolName"]) {
                    obj['School'] = item["schoolName"]
                }
                if (item["grade"]) {
                    obj['Class'] = item["grade"]
                }
                if (item["section"]) {
                    obj['Section'] = item["section"]
                }


                if (item["studentNumber"]) {
                    obj['Roll No'] = item["studentNumber"]
                }
                if (item["gender"]) {
                    obj['Gender'] = item["gender"]
                }
                if (item["studentCode"]) {
                    obj['Student Code'] = item["studentCode"]
                }
                if (item["userName"]) {
                    obj['Student Name'] = item["userName"]
                }

                if (item["projectName"]) {
                    obj['Project Name'] = item["projectName"]
                }

                if (item["dateOfAssessment"]) {
                    let dateFormat = new Date(item['dateOfAssessment']).toLocaleString('en-ZA').split(',');
                    obj['Date of Assessment'] = dateFormat[0]
                }

                if (item["examYear"]) {
                    obj['Exam Year'] = item["examYear"]
                }

                if (item["markScored"]) {
                    obj['Mark Scored'] = item["markScored"]
                }

                if (item["totalMark"]) {
                    obj['Total Mark'] = item["totalMark"]
                }

                csvBuild.push(obj)
            }
            let json2csvParser = new Parser();
            let csv = json2csvParser.parse(csvBuild);

            // console.log(csv);

            let hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = `${this.state.assessmentName}_Assessment_Student_Summary_Report_` + (new Date).toISOString() + '.csv';
            hiddenElement.click();
        }
    }

    showClickerAssessmentList() {
        this.setState({ showAssessmentEndScreen: false })
        this.props.delegate && this.props.delegate.showClickerAssessmentList && this.props.delegate.showClickerAssessmentList()
    }

    downloadStudentWiseQuestionExcel() {
        let studentQuestionDetails = this.state.studentQuestionDetails

        if (studentQuestionDetails && studentQuestionDetails.length) {
            let csvBuild = []
            for (let i = 0; i < studentQuestionDetails.length; i++) {
                let item = studentQuestionDetails[i]

                let obj = {
                }

                if (item["state"]) {
                    obj['State'] = item["state"]
                }

                if (item["location"]) {
                    obj['Location'] = item["location"]
                }

                if (item["schoolName"]) {
                    obj['School'] = item["schoolName"]
                }
                if (item["grade"]) {
                    obj['Class'] = item["grade"]
                }
                if (item["section"]) {
                    obj['Section'] = item["section"]
                }


                if (item["studentNumber"]) {
                    obj['Roll No'] = item["studentNumber"]
                }
                if (item["gender"]) {
                    obj['Gender'] = item["gender"]
                }
                if (item["studentCode"]) {
                    obj['Student Code'] = item["studentCode"]
                }
                if (item["userName"]) {
                    obj['Student Name'] = item["userName"]
                }
                if (item["projectName"]) {
                    obj['Project Name'] = item["projectName"]
                }

                if (item["dateOfAssessment"]) {
                    let dateFormat = new Date(item['dateOfAssessment']).toLocaleString('en-ZA').split(',');
                    obj['Date of Assessment'] = dateFormat[0]
                }

                if (item["examYear"]) {
                    obj['Exam Year'] = item["examYear"]
                }



                if (item["questionNumber"]) {
                    obj['Question Number'] = item["questionNumber"]
                }

                if (item["questionTitle"]) {
                    obj['Question'] = item["questionTitle"]
                }

                if (item["competencyThinkingSkill"]) {
                    obj['Competency'] = item["competencyThinkingSkill"]
                }

                if (item["complexity"]) {
                    obj['Complexity'] = item["complexity"]
                }

                if (item["mark"]) {
                    obj['Mark'] = item["mark"]
                }




                if (item["cleared"]) {
                    obj['Cleared(Yes / No)'] = item["cleared"]
                }

                csvBuild.push(obj)
            }
            let json2csvParser = new Parser();
            let csv = json2csvParser.parse(csvBuild);

            // console.log(csv);

            let hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = `${this.state.assessmentName}_studentwise_question_Report_` + (new Date).toISOString() + '.csv';
            hiddenElement.click();
        }
    }




    viewReportModal = () => {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideReportModal} size={'md'}>
                <ModalBody >
                    <div className="homework-assign-popup">
                        <div className="d-flex justify-content-between heading">
                            <div className="">{this.state.assessmentName} Report<div className="heading-subtext">{this.state.selectedConceptName}</div></div>
                            <div className="my-auto"><img className='close-icon close-icon-position cursor-pointer' src={getImageSource(ImageConstants.WHITE_CLOSE_ICON)} onClick={this.hideReportModal} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color border-bottom"
                            onClick={() => this.downloadQuestionwiseReportExcel()}
                        >
                            <div className="cursor-pointer">Download Questionwise Percentage Report </div>
                            <div><img className='block-download-icon cursor-pointer' src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color border-bottom"
                            onClick={() => this.downloadStudentWiseQuestionExcel()}
                        >
                            <div className="cursor-pointer">Download Studentwise Question Report</div>
                            <div><img className='block-download-icon cursor-pointer' src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color border-bottom"
                            onClick={() => this.downloadStudentSummaryReportExcel()}
                        >
                            <div className="cursor-pointer">Download Student Summary Report</div>
                            <div><img className='block-download-icon cursor-pointer' src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color"
                            onClick={() => this.downloadFeedbackReportExcel()}
                        >
                            <div className="cursor-pointer">Download Feedback Report</div>
                            <div><img className='block-download-icon cursor-pointer' src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)} /></div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }




    render() {

        console.log(this.state.showAssessmentStartScreen)

        if (this.state.showAssessmentStartScreen && CommonUtils.isOnline()) {
            return (
                <StartAssessment delegate={this} 
                meta={this.state.startAssessmentMetaInfo} 
                studentList={this.state.usersList} 
                isOnline={CommonUtils.isOnline()}
                selectedSetOption = {this.props.selectedSetOption ? this.props.selectedSetOption : {}} />
            )
        } else if (this.state.showAssessmentStartScreen && !CommonUtils.isOnline()) {
            return (
                <StartAssessment delegate={this} meta={this.state.startAssessmentMetaInfo} studentList={this.state.usersList}
                    isOnline={CommonUtils.isOnline()} />
            )
        }

        if (this.state.showAssessmentEngine && CommonUtils.isOnline()) {
            return (
                <ClickerAssessmentEngine meta={

                    // chapterKey: this.state.chapterKey,
                    // chapterTitle: this.state.chapterTitle,
                    // categoryThemeId: this.state.categoryThemeId,

                    // questionSetId: this.state.questionSetId
                    this.state.assessmentEngineMetaInfo
                }
                    delegate={this}
                    studentList={this.state.usersList}
                    isFFF={this.state.isFFF}
                    showLargeStudentResponseSideBar={true} />
            )
        } else if (this.state.showAssessmentEngine && !CommonUtils.isOnline()) {
            return (
                <ClickerOfflineAssessmentEngine meta={

                    // chapterKey: this.state.chapterKey,
                    // chapterTitle: this.state.chapterTitle,
                    // categoryThemeId: this.state.categoryThemeId,

                    // questionSetId: this.state.questionSetId
                    this.state.assessmentEngineMetaInfo
                }
                    delegate={this}
                    studentList={this.state.usersList}
                    isFFF={this.state.isFFF}
                    showLargeStudentResponseSideBar={true} />
            )
        }

        if (this.state.showAssessmentEndScreen) {
            return (
                <ClickerAssessmentEndScreen metaInfo={this.state.assessmentCompletedMetaInfo} delegate={this} studentList={this.state.usersList} />
            )
        }




        return (
            <div className="clicker-flow-practice">
                <div>
                    <ClassworkHeader delegate={this.props.delegate} showActiveFilter={this.state.showActiveFilter} />
                    {
                        this.state.content.map((item, index) => (
                            <div key={item._id} className="card-wrapper">
                                {
                                    <ClickerFlowPracticeStat
                                        item={item}
                                        index={index}
                                        delegate={this}
                                        categoryId={1}
                                        content={this.state.content}
                                        status={item.status}
                                        updateItem={this.updateItem}
                                    />
                                }
                            </div>
                        ))
                    }
                    {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
                    {
                        this.state.showDownloadReportPopup ? this.viewReportModal() : <></>
                    }
                </div>
            </div>
        )
    }

}

export default ClickerFlowPractice;